import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { sortUsersByName } from '../utils/sorting';
import { browserHistory } from 'react-router';
import roles from '../utils/roles';

import Spinner from './Spinner';
import UsersOverviewUserPill from './UsersOverviewUserPill';

import projectActions from '../actions/projectActionCreators';
import userActions from '../actions/userActionCreators';
import userTaskActions from '../actions/userTaskActionCreators';
import taskActions from '../actions/taskActionCreators';
import customerActions from '../actions/customerActionCreators';

class UsersOverview extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            filterText: "",
            selectedUserID: null,
            showActive: false,
            showInactive: false
        };
    }

     // LIFECYCLE METHODS

    componentDidMount = () => {
        this.props.dispatch(userActions.loadAllForUsersOverview());
        this.props.dispatch(projectActions.pmoLoadAllProjectsForUsersOverview());
        this.props.dispatch(taskActions.pmoLoadAll());
    }

    componentWillReceiveProps = (nextProps) => {
        if (nextProps.currentUser) {
            //way to transition to root using react-router if user has no roles
            if(!roles.userHasAnyOfRoles(nextProps.currentUser, ['PMO'])) {
                browserHistory.push('/');
            }
        }
    }

    // EVENT HANDLERS

    handleActiveClick = () => {
        this.setState({
            showActive: !this.state.showActive,
            showInactive: false
        });
    }

    handleFilterChange = (event) => { this.setState({ filterText: event.target.value }); }

    handleInactiveClick = () => {
        this.setState({
            showInactive: !this.state.showInactive,
            showActive: false
        });
    }

    handleUserPillClick = (userID) => {
        this.props.dispatch(projectActions.loadByUser(userID));
        this.props.dispatch(userTaskActions.loadByUser(userID));
        this.props.dispatch(userActions.loadUserByID(userID));

        this.setState({ selectedUserID: this.state.selectedUserID === userID ? null : userID });
    }

    // OTHER METHODS

    clearFilter = () => { this.setState({ filterText: "" }); }

    filterUsers = (list) => {
        let filter = new RegExp(this.state.filterText.replace(/  +/g, ' '), 'i');
        return list.filter(user => filter.test(user.givenName) || filter.test(user.surname) || filter.test(user.username) || filter.test(user.givenName + ' ' + user.surname) || filter.test(user.surname + ' ' + user.givenName));
    };

    syncUsersWithLdap = () => { this.props.dispatch(userActions.syncUsersWithLDAP()); }
    syncUserIdsWithAkira = () => { this.props.dispatch(userActions.syncUserIdsWithAkira()); }
    syncCompaniesWithErp = () => { this.props.dispatch(customerActions.sync()); }

    // RENDER METHOD

    render = () => {
        let filteredActiveUsers   = this.filterUsers(this.props.activeUsers);
        let filteredInactiveUsers = this.filterUsers(this.props.inactiveUsers);
        let disableSync = this.props.loading || this.props.syncing;

        return (
            <div className="container">
                <br/>
                <div className="text-center">
                    <span style={{padding: "5px"}}>
                        <button title="Synchronize users with LDAP. Applications needs to be refreshed for the changes to show." type="button" className="btn btn-default btn-large" onClick={this.syncUsersWithLdap} disabled={disableSync}>
                            Sync users with LDAP
                        </button>
                    </span>
                    <span style={{padding: "5px"}}>
                        <button title="Synchronize user IDs with Akira. Applications needs to be refreshed for the changes to show." type="button" className="btn btn-default btn-large" onClick={this.syncUserIdsWithAkira} disabled={disableSync}>
                            Sync user IDs with Akira
                        </button>
                    </span>
                    <span style={{padding: "5px"}}>
                        <button title="Manually synchronize customers with ERP." type="button" className="btn btn-default btn-large" onClick={this.syncCompaniesWithErp} disabled={disableSync}>
                            Sync customers with ERP
                        </button>
                    </span>
                </div>
                <br/>
                <div className="panel-filter">
                    <div className="form-group">
                        <label>Filter:</label>
                        <input onChange={this.handleFilterChange} value={this.state.filterText} type="text" className="form-control" placeholder="User Name"/>
                        <a style={{"cursor" : "pointer", paddingRight : "10px", paddingTop : "5px"}} onClick={this.clearFilter} className="filter-clear"><span><span className="md-clear"/></span></a>
                    </div>
                </div>
                {
                    this.props.loading || this.props.syncing
                    ? <span><br/><Spinner/></span>
                    :
                        filteredActiveUsers.length > 0
                        ? <div style={{"marginBottom" : "-10px"}} className="panel-group project floating-manage" key={1} id={1}>
                            <div className="panel panel-default panel-pmproject" >
                                <div key={1} id="1" className="panel-heading" role="tab">
                                    <h4 className="panel-title" style={{backgroundColor : "#888"}}>
                                    <a style={{"cursor" : "pointer"}} onClick={this.handleActiveClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                                        <span className="acc"><span className={this.state.showActive ? "md-expand-more" : "md-chevron-right"}/></span>
                                        Active users ({filteredActiveUsers.length})
                                    </a>
                                    </h4>
                                </div>
                                <div key={2} id="2" className={this.state.showActive ? "panel-collapse" : "panel-collapse collapse"} role="tabpanel" aria-labelledby="headingThree">
                                    <div className="panel-body">
                                    {
                                        filteredActiveUsers.map((user, key) => {
                                            return (<UsersOverviewUserPill
                                                       handleClick={this.handleUserPillClick}
                                                       id={key}
                                                       isUserPillActive={this.state.selectedUserID === user.id}
                                                       key={key}
                                                       user={user}
                                                       isUserActive
                                                       />);
                                        })
                                    }
                                    </div>
                                </div>
                            </div>
                         </div>
                        : null
                }
                {
                    filteredInactiveUsers.length && !(this.props.loading || this.props.syncing) > 0 ?
                    <div className="panel-group project floating-manage" key={2} id="2">
                        <div className="panel panel-default panel-pmproject" >
                            <div key={1} className="panel-heading" role="tab" id="1">
                                <h4 className="panel-title" style={{backgroundColor : "#888"}}>
                                <a style={{"cursor" : "pointer"}} onClick={this.handleInactiveClick} className="collapsed" data-toggle="collapse" data-parent="#accordion-outer" aria-expanded="false" aria-controls="collapseThree-outer">
                                    <span className="acc"><span className={this.state.showInactive ? "md-expand-more" : "md-chevron-right"}/></span>
                                    Inactive users ({filteredInactiveUsers.length})
                                </a>
                                </h4>
                            </div>
                            <div key={2} id="2" className={this.state.showInactive ? "panel-collapse" : "panel-collapse collapse"} role="tabpanel" aria-labelledby="headingThree">
                                <div className="panel-body">
                                {
                                    filteredInactiveUsers.map((user, key) => {
                                        return (<UsersOverviewUserPill
                                                   handleClick={this.handleUserPillClick}
                                                   id={key}
                                                   isUserPillActive={this.state.selectedUserID === user.id}
                                                   isUserActive={false}
                                                   key={key}
                                                   user={user}
                                                   />);
                                    })
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
                }
            </div>
        );
    }
}

UsersOverview.propTypes = {
    activeUsers: PropTypes.array,
    currentUser: PropTypes.object,
    dispatch: PropTypes.func,
    inactiveUsers: PropTypes.array,
    loading: PropTypes.bool,
    syncing: PropTypes.bool,
};

const mapStateToProps = (state) => {
    let users = state.users.usersForUsersOverview.sort(sortUsersByName);

    return {
        activeUsers: users.filter(user => user.active),
        currentUser: state.users.currentUser,
        inactiveUsers: users.filter(user => !user.active),
        loading: state.users.loading || state.customers.loading,
        syncing: state.users.syncing || state.customers.syncing
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UsersOverview);



/** WEBPACK FOOTER **
 ** ./src/app/components/UsersOverview.js
 **/